<template>
    <u-tooltip-opacity-rounded v-bind="$attrs">
        <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
            <slot :name="scopedSlotName" v-bind="slotData" />
        </template>
    </u-tooltip-opacity-rounded>
</template>

<script>
import UTooltipOpacityRounded from "@/components/publish/styles/tooltips/u-tooltip-opacity-rounded.vue";

export default {
    props: {},
    components: {
        UTooltipOpacityRounded,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
